import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        url: String
    }

    connect() {
        if (this.hasUrlValue) {
            this.initializeSelect2()
        }
    }

    initializeSelect2() {
        $(this.element).select2({
            ajax: {
                url: this.urlValue,
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        page: params.page
                    }
                },
                processResults: function (data, params) {
                    params.page = params.page || 1
                    return {
                        results: data.items,
                        pagination: {
                            more: data.more
                        }
                    }
                }
            }
        })
    }
}